// removed by extract-text-webpack-plugin
module.exports = {"component":"Root__component___g_2tL","routes":"Root__routes___16bn1"};


//////////////////
// WEBPACK FOOTER
// ./src/root/components/Root.css
// module id = 427
// module chunks = 0